define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerModel = /** @class */ (function () {
        function CustomerModel(data) {
            this.Id = ko.observable(0);
            this.AccountNumber = ko.observable(0);
            this.Name = ko.observable();
            this.AliasNames = ko.observable();
            this.Domain = ko.observable();
            this.SubDomain = ko.observable();
            this.MainDomain = ko.observable();
            this.ProvisioningCode = ko.observable();
            this.Email = ko.observable();
            this.IsDeleted = ko.observable(false);
            this.DomainIpAddress = ko.observable();
            this.AuthorizedDecisionMakerName = ko.observable();
            this.Ownername = ko.observable();
            this.CustomerStatusId = ko.observable();
            this.HHAKey = ko.observable();
            this.HHAEnabled = ko.observable();
            this.ProjectManagerId = ko.observable();
            this.AccountManagerId = ko.observable();
            this.AgentId = ko.observable();
            this.CustomerTypeId = ko.observable();
            this.CustomerProfileId = ko.observable();
            this.BrandInternalId = ko.observable();
            this.TaxExempt = ko.observable();
            this.TaxNotes = ko.observable();
            this.Tax1Name = ko.observable();
            this.Tax2Name = ko.observable();
            this.CustomerKey = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerModel.Mapping, self);
            }
            self.Title = ko.computed(function () {
                var name = "";
                var domain = "";
                if (self.Name()) {
                    name = self.Name();
                }
                if (self.Domain()) {
                    domain = self.Domain();
                }
                return name /*+ ' (<a target="_blank" href="http://'+domain+'">' + domain + '</a>)'*/;
            });
        }
        CustomerModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerModel(options.data);
            }
        };
        return CustomerModel;
    }());
    return CustomerModel;
});
//# sourceMappingURL=CustomerModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerModel.js
// module id = 32
// module chunks = 2